import { memo, useEffect } from 'react';

import { OrganizationalStructure } from "PDF/components/OrganizationalStructure";
import { PDF_SECTIONS } from "PDF/constants/sections";
import { prepareSectionId } from "PDF/helpers/pdfMapping";
import { useGenerateImageFromElement } from "PDF/hooks/useGenerateImageFromElement";
import { IPdfPageProps } from "PDF/types/pdf";
import { useBusinessToolStore } from "store/useBusinessToolStore";
import { getBusinessPlanChapters, getBusinessPlanType } from "store/useBusinessToolStore/selectors";

import { useExamplePreview } from 'hooks/useExamplePreview';

import { getKeyPersonnelProfiles, getMagazineItems, getOrganizationalStructure, getProfiles } from "./mapping";

export const ManagementAndOrganization = memo(({ saveSectionProps, sectionPicture }: IPdfPageProps) => {
  const businessPlanChapters = useBusinessToolStore(getBusinessPlanChapters);
  const businessPlanType = useBusinessToolStore(getBusinessPlanType);
  const { isExamplePage } = useExamplePreview();

  const magazineItems = getMagazineItems(businessPlanChapters, businessPlanType, isExamplePage);
  const keyPersonnelProfiles = getKeyPersonnelProfiles(businessPlanChapters, isExamplePage);
  const profiles = getProfiles(businessPlanChapters, isExamplePage);
  const organizationalStructure = getOrganizationalStructure(businessPlanChapters);
  const [portal, organizationalStructureImgSrc] = useGenerateImageFromElement(
    <OrganizationalStructure data={organizationalStructure} />
  );

  useEffect(() => {
    if (organizationalStructureImgSrc && sectionPicture) {
      const organizationalStructureImg = organizationalStructure.level1Department ? organizationalStructureImgSrc : '';
      const data = {
        keyPersonnelProfiles,
        profiles,
        organizationalStructureImg,
      };

      saveSectionProps(prepareSectionId(businessPlanType, PDF_SECTIONS.MANAGEMENT_AND_ORGANIZATION), {
        magazineItems,
        data,
      });
    }
  }, [organizationalStructureImgSrc, sectionPicture]);

  return <>
    {portal}
  </>;
})
